module.exports = __webpack_public_path__ + "static/media/hero-banner-lg.c5814f2f.jpg";